import Button from 'components/ui-components/Button';

const HomepageCarouselButtons = ({ promoData, activeSlide, onClick }) => (
  <div className="homepage-carousel-buttons fl jc-c g-2">
    {promoData.map(({ id, title }, index) => (
      <Button
        key={`button-${id}`}
        className={`homepage-carousel-button ${
          index === activeSlide ? 'active' : ''
        }`}
        handleClick={() => onClick(index)}
        label={`Go to slide ${index + 1}`}>
        {title}
      </Button>
    ))}
  </div>
);

export default HomepageCarouselButtons;
